import { Component } from '@angular/core';

@Component({
  selector: 'placeme-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.scss'],
})
export class TeamsComponent {}
